import { useEffect } from 'react';

type BodyStyleSnapshot = {
  bodyOverflow: string;
  bodyPaddingRight: string;
  bodyOverscrollBehavior: string;
  bodyTouchAction: string;
  htmlOverflow: string;
  htmlOverscrollBehavior: string;
};

let activeLocks = 0;
let snapshot: BodyStyleSnapshot | null = null;

const canUseDom = (): boolean => {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
};

const lockBodyScroll = () => {
  if (!canUseDom()) {
    return;
  }

  const body = document.body;
  const html = document.documentElement;

  if (activeLocks === 0) {
    snapshot = {
      bodyOverflow: body.style.overflow,
      bodyPaddingRight: body.style.paddingRight,
      bodyOverscrollBehavior: body.style.overscrollBehavior,
      bodyTouchAction: body.style.touchAction,
      htmlOverflow: html.style.overflow,
      htmlOverscrollBehavior: html.style.overscrollBehavior
    };

    const scrollbarGap = Math.max(0, window.innerWidth - html.clientWidth);

    html.style.overflow = 'hidden';
    html.style.overscrollBehavior = 'none';
    body.style.overflow = 'hidden';
    body.style.overscrollBehavior = 'none';
    body.style.touchAction = 'none';

    if (scrollbarGap > 0) {
      body.style.paddingRight = `${scrollbarGap}px`;
    }
  }

  activeLocks += 1;
};

const unlockBodyScroll = () => {
  if (!canUseDom() || activeLocks === 0) {
    return;
  }

  activeLocks -= 1;

  if (activeLocks === 0) {
    const body = document.body;
    const html = document.documentElement;
    body.style.overflow = snapshot?.bodyOverflow ?? '';
    body.style.paddingRight = snapshot?.bodyPaddingRight ?? '';
    body.style.overscrollBehavior = snapshot?.bodyOverscrollBehavior ?? '';
    body.style.touchAction = snapshot?.bodyTouchAction ?? '';
    html.style.overflow = snapshot?.htmlOverflow ?? '';
    html.style.overscrollBehavior = snapshot?.htmlOverscrollBehavior ?? '';
    snapshot = null;
  }
};

export const useBodyScrollLock = (locked: boolean) => {
  useEffect(() => {
    if (!locked) {
      return;
    }

    lockBodyScroll();
    return () => {
      unlockBodyScroll();
    };
  }, [locked]);
};
